import Caption from '@algbra/ui/components/Caption/Caption'
import { Column, Container, Row } from '@algbra/ui/components/Grid/Grid'
import Heading from '@algbra/ui/components/Heading/Heading'
import Whitespace from '@algbra/ui/components/Whitespace/Whitespace'
import { VAlign } from '@algbra/ui/enums/align'
import { GatsbyResolvedAsset } from '@algbra/ui/types/image'
import { GatsbyImage } from 'gatsby-plugin-image'
import { mapIndexed } from 'rambdax'
import React from 'react'
import { resolveAsImage } from '@algbra/ui/resolvers'
import styles from './IconContentBoxList.module.scss'

export type IconContentBox = {
  title: string
  image?: GatsbyResolvedAsset
}
export type ZoneIconContentBoxListProps = {
  __typename: 'StrapiGQL_ComponentZonesIconContentBoxList'
  title: string
  list: IconContentBox[]
}
export default function ZoneIconContentBoxList(
  props: ZoneIconContentBoxListProps
) {
  const { title, list } = props
  return (
    <Whitespace type="md">
      <Container>
        <Heading level={2} type="lg" className={styles.title}>
          {title}
        </Heading>

        <Row className={styles.list} vAlign={VAlign.STRETCH}>
          {mapIndexed(
            ({ title, image }, index) => (
              <Column size={9} sm={6} lg={4} key={`icon-item-${index}`} className={styles.itemWrapper}>
                <div className={styles.item}>
                  <Caption type="lg">{title}</Caption>
                  <GatsbyImage
                    image={resolveAsImage(image)}
                    alt=""
                    className={styles.image}
                  />
                </div>
              </Column>
            ),
            list
          )}
        </Row>
      </Container>
    </Whitespace>
  )
}
